// src/pages/ClientDashboard.jsx
import React from "react";
import TalleresMap from "./TalleresMap"; // Ajusta la ruta

const ClientDashboard = () => {
  return (
    <div style={{ backgroundColor: "#1f1f1f", color: "#ccc", height: "100vh" }}>
      {/* Aquí se muestra el mapa con filtros */}
      <TalleresMap />
    </div>
  );
};

export default ClientDashboard;
